module.exports = "/_next/static/images/moderate_volatility-a0f8ad0cae1ace9c1716514b69f50799.svg";